import React from "react"

// components
import InputField from "../../InputField/InputField.component"

// mui
import { Grid, Paper, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

const AddEquipmentRequestItemInput = ({ title, subTitle, prefix, handleChange, requestedQuantity, handleRemove, errors }) => {


    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>

        <Grid item xs={11}>
            <Paper variant="outlined" sx={{ padding: 2, paddingBottom: 0, marginBottom: 2 }}>
                <Grid container spacing={2}>
                    <Grid container item xs={6}>
                        <Grid item xs={12}><Typography varinat="h6">{title}</Typography></Grid>
                        <Grid item xs={12}><Typography variant="subtitle1">{subTitle}</Typography></Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <InputField 
                            id={`${prefix}.requestedQuantity`}
                            type="text"
                            placeholder='Requested Quantity'
                            onChange={handleChange}
                            value={requestedQuantity}
                            isValid={errors['requestedQuantity']}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </Grid>)
}

export default AddEquipmentRequestItemInput